import React from 'react'
import { SkeletonMap } from '@/utils/varsManipulations'
import { NotificationSkeletonProps } from './types'
import './style.css'
import { CRRender } from '@/components/crRender'
import SkeletonBase from '@/components/skeletonBase'

const SKELETON_COUNT = 3

const Skeleton: React.FC<NotificationSkeletonProps> = ({ isRender }) => {
  return (
    <CRRender isRender={isRender}>
      {SkeletonMap(SKELETON_COUNT, (i) => (
        <div
          key={i}
          className="notification-container notification-skeleton"
          aria-hidden
        >
          <div className="notification-skeleton__body">
            <SkeletonBase
              className="notification-skeleton__line"
              variant="rounded"
              width="100%"
              height="12px"
            />
            <SkeletonBase
              className="notification-skeleton__line notification-skeleton__line--short"
              variant="rounded"
              width="78%"
              height="12px"
            />
            <SkeletonBase
              className="notification-skeleton__line notification-skeleton__line--link"
              variant="rounded"
              width="42%"
              height="12px"
            />
          </div>
          <SkeletonBase
            className="notification-skeleton__date"
            variant="rounded"
            width="70px"
            height="10px"
          />
          <SkeletonBase
            className="notification-skeleton__icon"
            variant="circular"
            width="20px"
            height="20px"
          />
        </div>
      ))}
    </CRRender>
  )
}

export default Skeleton
